export function isValidCSharpInt(value: number): boolean {
   const CSHARP_UINT_MIN = 0;
   const CSHARP_UINT_MAX = 4294967295;

   return value >= CSHARP_UINT_MIN && value <= CSHARP_UINT_MAX;
}
